// vendor
import { Ref, ComputedRef } from "@vue/composition-api";
// project
import { useAppModals } from "@/hooks/useAppModals";
import {
	EditTextConfig, EditTextHandler,
	EditColorConfig, EditColorHandler,
	ConfirmConfig, ConfirmHandler,
	FindIconConfig, FindIconHandler,
	UploadFileConfig, UploadFileHandler,
} from "@/components.generic/utility-modal";
import { ContextOption, ContextConfig } from "@/components.generic/context-menu";
import { StudyWizardConfig, StudyWizardHandler } from "@/components.studies/create-study-wizard";
import { CreateAssetConfig, CreateAssetHandler } from "@/components.assets/create-asset-wizard";
import { ModalConfig as FindAssetConfig, ResultFn as FindAssetHandler } from "@/components.assets/browse-asset-modal";

export const editText = (c:EditTextConfig, fn:EditTextHandler) => {
	const { editText } = useAppModals();
	if(!editText.value){ return; }
	editText.value.open(c, fn);
};

export const editColor = (c:EditColorConfig, fn:EditColorHandler) => {
	const { editColor } = useAppModals();
	if(!editColor.value){ return; }
	editColor.value.open(c, fn);
};

export const confirm = (c:ConfirmConfig, fn:ConfirmHandler) => {
	const { confirm } = useAppModals();
	if(!confirm.value){ return; }
	confirm.value.open(c, fn);
};

export const context = (event:Event, options:ContextOption[], c?:ContextConfig) => {
	const { context } = useAppModals();
	if(!context.value){ return; }
	context.value.open(event, options, c);
};

export const createStudy = (c:StudyWizardConfig, fn:StudyWizardHandler) => {
	const { createStudy } = useAppModals();
	if(!createStudy.value){ return; }
	createStudy.value.open(c, fn);
};

export const findIcon = (c:FindIconConfig, fn:FindIconHandler) => {
	const { findIcon } = useAppModals();
	if(!findIcon.value){ return; }
	findIcon.value.open(c, fn);
};

export const uploadFile = (c:UploadFileConfig, fn:UploadFileHandler) => {
	const { uploadFile } = useAppModals();
	if(!uploadFile.value){ return; }
	uploadFile.value.open(c, fn);
};

export const findAsset = (c:FindAssetConfig, fn:FindAssetHandler) => {
	const { findAsset } = useAppModals();
	if(!findAsset.value){ return; }
	findAsset.value.open(c, fn);
};

export const createAsset = (c:CreateAssetConfig, fn:CreateAssetHandler) => {
	// const { createAsset } = useAppModals();
	// if(!createAsset.value){ return; }
	// createAsset.value.open(c, fn);
	open(useAppModals().createAsset, c, fn);
};


const open = <CT, HT>(m:Ref<{ open:(c:CT, fn:HT) => void }|undefined>, c:CT, fn:HT) => {
	if(!m.value){ return; }
	m.value.open(c, fn);
};